import { Observable } from 'rxjs';
import ResizeObserver from 'resize-observer-polyfill';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export const smallSizeWidthPx = 1024;
export const isWindowSizeSmall = (): boolean => window.screen.width <= smallSizeWidthPx || window.innerWidth <= smallSizeWidthPx;

export const isViewportSmall = (): boolean => window.innerWidth <= smallSizeWidthPx;

export const getComputedPropPx = (el: Element, prop: string): number => parseInt(window.getComputedStyle(el)[prop], 10);

export const getComputedWidthPx = (el: Element): number => getComputedPropPx(el, 'width');

export const platformIsMac = (): boolean => window.navigator.platform.includes('Mac');

/**
 * Listen to specific DOM element height resize events
 * @param target
 * @param debounce
 */
export function fromResizeEvent<T extends Element>(target: T, debounce: number): Observable<{ width: number; height: number }> {
  return new Observable<{ width: number; height: number }>((observer) => {
    const resizeObserver = new ResizeObserver(([entry]: [ ResizeObserverEntry? ]) => {
      if (entry) {
        observer.next({ width: entry.contentRect.width, height: entry.contentRect.height });
      }
    });

    resizeObserver.observe(target);
    observer.add(() => resizeObserver.disconnect());
  }).pipe(
    distinctUntilChanged(),
    debounceTime(debounce),
  );
}
